<template>
  <b-button @click="$emit('click', $event)" size="sm" variant="info" v-b-tooltip.hover :title="showToolTip ? 'Установить пароль' : ''"><i class="fa fa-key"></i></b-button>
</template>

<script>

export default ({
  name: "button-set-password",
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  }
})
</script>
